import React, { useCallback } from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import {
  EPolicyFields,
  EPolicySeverity,
  ESeverityColors,
  SEVERITY_LIST,
} from '../../types/policies-types';
import { updateProfilePolicyProps } from '../../actions/policies-profile-actions/policy-state-actions';
import { enablePoliciesSaveButton } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';

interface SeverityDropDownProps {
  severity: EPolicySeverity;
  id: string;
}

const SeverityDropDown: React.FC<
  React.PropsWithChildren<SeverityDropDownProps>
> = ({ severity, id }) => {
  const handleChange = useCallback(
    (event: SelectChangeEvent<EPolicySeverity>) => {
      event.stopPropagation();
      enablePoliciesSaveButton(true);
      const value = event.target.value as EPolicySeverity;
      updateProfilePolicyProps({
        id,
        field: EPolicyFields.severity,
        value,
      });
    },
    [id],
  );

  return (
    <FormControl margin='none' size='small' sx={{ width: 160, mr: 2 }}>
      <Select
        sx={{ maxHeight: 30 }}
        className='policy-severity-box'
        margin='none'
        size='small'
        name={EPolicyFields.severity}
        value={severity}
        onChange={handleChange}>
        {SEVERITY_LIST.map(([k, v]) => {
          return (
            <MenuItem key={k} onClick={e => e.stopPropagation()} value={v}>
              <Typography color={ESeverityColors[k]} variant='button'>
                {k}
              </Typography>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SeverityDropDown;
